import styled, { css } from 'styled-components';
import { themeColor } from '~/common/utils/theme';
import { Typography } from '~/ui/components';

export const Wrapper = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > span {
    width: 100%;
    max-width: 220px;
    color: ${({ theme }) => theme.colors.element.secondary};
  }

  ${({ loading }) =>
    loading &&
    css`
      pointer-events: none;
      opacity: 0.6;
    `}
`;

export const PaginationContent = styled.ul`
  display: flex;
  list-style-type: none;
  gap: 16px;
  margin-bottom: 0;
`;

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 220px;
  justify-content: flex-end;
`;

export const Select = styled.select`
  padding: 6px 32px 6px 12px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.background.primary};
  color: ${({ theme }) => theme.colors.element.primary};
  border: 1px solid ${({ theme }) => theme.colors.divider.primary};
  height: 40px;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23D80073' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;

  &:focus {
    border-color: ${({ theme }) => theme.colors.divider.primary};
    box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.2);
  }
`;

export const SelectLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.element.secondary};
`;

export const Item = styled.li`
  list-style-type: none;
  min-width: 40px;
  height: 40px;
  border: 1px solid ${({ theme }) => theme.colors.divider.primary};
  opacity: ${({ disabled }) => (disabled ? 0.3 : 100)};
  border-radius: 4px;
  display: flex;
  justify-content: center;

  .typography {
    color: ${({ theme }) => theme.colors.element.primary};
  }

  ${({ currentPage }) =>
    currentPage &&
    css`
      border: 1px solid ${({ theme }) => theme.colors.brand.primary};
      background-color: ${({ theme }) => theme.colors.brand.primary};

      .typography {
        color: ${({ theme }) => theme.colors.background.primary};
      }
    `};
`;

export const Button = styled.button`
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  width: 100%;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;
